// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"

import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "@/styles/base.css"

import "./icons" // icon

Vue.use(ElementUI)
//

import * as filters from "./filters" // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import ApolloClient from "apollo-boost"

let baseURL = ""
if (process.env.NODE_ENV === "development") {
  // baseURL = "http://45.32.9.103:5900/uapi" //
  baseURL = "http://localhost:5100/uapi" //
} else {
  baseURL = "//" + location.hostname + ":" + location.port + "/api"
}

const apolloClient = new ApolloClient({
  // 你需要在这里使用绝对路径
  // uri: "http://172.16.16.133:5100/aapi",
  uri: baseURL
})

import VueApollo from "vue-apollo"
Vue.use(VueApollo)
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

import VueClipboard from "vue-clipboard2"
Vue.use(VueClipboard) //必须这样子引用 否则会报错的
//

import JsonViewer from "vue-json-viewer"
Vue.use(JsonViewer)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.vue = new Vue({
  el: "#app",
  apolloProvider,
  router,

  // components: { App },
  // template: "<App/>"
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js